interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma 75644:18530 "lock (9) 1". */
const FigmaMapLockIcon = ({ width = 20, height = 20, color = '#121826' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.8333 6.89667V5.83333C15.8333 2.61667 13.2158 0 10 0C6.78417 0 4.16667 2.61667 4.16667 5.83333V6.89667C2.715 7.41417 1.66667 8.78917 1.66667 10.4167V16.25C1.66667 18.3175 3.34917 20 5.41667 20H14.5833C16.6508 20 18.3333 18.3175 18.3333 16.25V10.4167C18.3333 8.78917 17.285 7.415 15.8333 6.89667ZM5 5.83333C5 3.07583 7.2425 0.833333 10 0.833333C12.7575 0.833333 15 3.07583 15 5.83333V6.70917C14.8617 6.69333 14.7258 6.66667 14.5833 6.66667H5.41667C5.27417 6.66667 5.13833 6.69333 5 6.70917V5.83333ZM17.5 16.25C17.5 17.8583 16.1917 19.1667 14.5833 19.1667H5.41667C3.80833 19.1667 2.5 17.8583 2.5 16.25V10.4167C2.5 8.80833 3.80833 7.5 5.41667 7.5H14.5833C16.1917 7.5 17.5 8.80833 17.5 10.4167V16.25ZM10.4167 12.0833V14.5833C10.4167 14.8133 10.23 15 10 15C9.77 15 9.58333 14.8133 9.58333 14.5833V12.0833C9.58333 11.8533 9.77 11.6667 10 11.6667C10.23 11.6667 10.4167 11.8533 10.4167 12.0833Z'
      fill={color}
    />
  </svg>
);

export default FigmaMapLockIcon;
